import styled from 'styled-components';

export const PopupsWrapperStyled = styled.div`
  
`;